// Auto-generated from digital-asset-week.html. Verbatim redesign import. Do NOT edit.
export const STYLES = `
/* ============================================================
   T-REX, Digital Asset Week. Built to trex-design v4.

   FIVE TYPE ROLES, NOTHING ELSE:
     1 statement  Source Serif 4 400   hero only
     2 title      Source Serif 4 600   section titles only
     3 body       Inter 400/500 16px   every sentence, buttons, inputs
     4 label      JetBrains Mono 500 11px caps   eyebrows, captions, states
     5 figure     JetBrains Mono 600 26px        numbers only, never words

   Navigation is two clearly different objects, never two lists:
     the card fan  = the five questions (the physical cards, fanned)
     the rail      = where you are on the page (the line, run vertically,
                     with a seal at each checkpoint and one lava point at now)
   ============================================================ */
:root{
  --bone:#FAF8F4; --aubergine:#15102A; --purple:#4C3778;
  --champagne:#A88B4A; --lava:#FF7A33;
  --ink:#2E2842; --slate:#57516B; --faint:#8A859A;
  --mist:#B7B3C3; --border:#DCD9E2; --hairline:#EAE8EE; --tint:#F3F1F5;
  --champagne-light:#E8D9B8;
  --serif:'Source Serif 4',Georgia,serif;
  --ui:'Inter',Calibri,sans-serif;
  --mono:'JetBrains Mono',Consolas,monospace;
}
*{box-sizing:border-box}
html{-webkit-text-size-adjust:100%; scroll-behavior:smooth}
body{
  margin:0; background:var(--bone); color:var(--ink);
  font-family:var(--ui); font-weight:400; font-size:16px; line-height:1.6;
  -webkit-font-smoothing:antialiased; overflow-x:hidden;
}
.wrap{max-width:1060px; margin:0 auto; padding:0 24px}
@media (min-width:900px){ .wrap{padding:0 48px} }

/* role 1 */
.statement{
  font-family:var(--serif); font-weight:400; line-height:1.1; letter-spacing:-.012em;
  font-size:clamp(34px,7vw,56px); margin:0; color:var(--bone);
}
.statement i{font-style:italic; color:var(--champagne)}
/* role 2 */
.title{
  font-family:var(--serif); font-weight:600; line-height:1.18; letter-spacing:-.006em;
  font-size:clamp(25px,4.1vw,32px); margin:0; color:var(--aubergine);
}
.title i{font-style:italic; color:var(--champagne); font-weight:600}
/* role 3 */
p{margin:0 0 20px; max-width:66ch}
.lede{color:var(--aubergine); font-weight:500}
a{color:var(--purple)}
/* role 4 */
.label{
  font-family:var(--mono); font-weight:500; font-size:11px; line-height:1.5;
  letter-spacing:.08em; text-transform:uppercase; color:var(--faint);
  margin:0; display:block;
}
.label.strong{color:var(--aubergine)}
/* role 5 */
.figure{
  font-family:var(--mono); font-weight:600; font-size:26px; line-height:1;
  font-variant-numeric:tabular-nums; color:var(--aubergine); letter-spacing:-.01em;
}

/* the line device */
.line{position:relative; height:10px; margin:18px 0 24px}
.line .seal{position:absolute; left:0; top:0; width:10px; height:10px; background:var(--champagne)}
.line .rule{
  position:absolute; left:0; right:0; top:4px; height:2px; border-radius:1px;
  background:var(--champagne); transform:scaleX(0); transform-origin:0 50%;
}
.line.hero .rule{height:3px; top:3.5px}
.line.on-dark .seal,.line.on-dark .rule{background:var(--champagne-light)}
.line.is-in .rule{transform:scaleX(1); transition:transform 620ms cubic-bezier(.4,.14,.3,1) var(--d,0ms)}

.up{opacity:0; transform:translateY(8px)}
.up.is-in{opacity:1; transform:none;
  transition:opacity 400ms cubic-bezier(0,0,.3,1) var(--d,0ms), transform 400ms cubic-bezier(0,0,.3,1) var(--d,0ms)}

/* ---------- the rail: the line run vertically, seals as checkpoints ---------- */
/* the rail is hidden over the header and appears beside the cards, then tracks scroll */
.rail{position:fixed; left:9px; top:50%; transform:translateY(-50%); z-index:40;
      opacity:0; visibility:hidden; transition:opacity 260ms ease-out, visibility 260ms}
.rail.show{opacity:1; visibility:visible}
.rail .stem{position:absolute; left:4px; top:5px; bottom:5px; width:2px; background:rgba(168,139,74,.22)}
.rail .stem i{display:block; width:100%; height:100%; background:var(--champagne); transform:scaleY(0); transform-origin:50% 0}
.rail ol{list-style:none; margin:0; padding:0; position:relative}
.rail li{margin:0 0 20px}
.rail li:last-child{margin-bottom:0}
.rail a{display:grid; grid-template-columns:10px auto; gap:14px; align-items:center; text-decoration:none}
.rail .seal{
  width:10px; height:10px; background:var(--bone);
  box-shadow:inset 0 0 0 1px var(--champagne);
}
.rail a.done .seal{background:var(--champagne)}
.rail a.on .seal{background:var(--lava); box-shadow:inset 0 0 0 1px var(--lava)}
.rail .label{display:none; white-space:nowrap}
.rail a.on .label{color:var(--aubergine)}
@media (min-width:1240px){
  .rail{left:28px}
  .rail .label{display:block}
}
@media (max-width:520px){ .rail li{margin-bottom:16px} }

/* ---------- header ---------- */
.header{
  position:relative;
  background:radial-gradient(ellipse 70% 70% at 0% 0%, rgba(76,55,120,.30), transparent 62%), var(--aubergine);
  color:rgba(250,248,244,.74); padding:96px 0 52px;
}
@media (min-width:900px){ .header{padding:128px 0 76px} }
/* the mark sits in the corner of the screen, not inside the text column */
.header .logo{position:absolute; left:18px; top:16px; height:26px; width:auto; margin:0}
@media (min-width:900px){ .header .logo{left:26px; top:22px; height:30px} }
.header .label{color:var(--mist)}
.header p{margin:20px 0 0; max-width:50ch; color:rgba(250,248,244,.74)}

/* ---------- the card fan ---------- */
.deck{padding:40px 0 8px}
/* the deck runs the full viewport so the arc can spread wide */
.fan{
  position:relative; width:100vw; margin-left:calc(50% - 50vw); margin-top:26px;
  height:clamp(300px,80vw,480px);
  user-select:none; -webkit-user-select:none;
}
/* the drag surface sits above the cards. touch-action pan-y means a vertical
   swipe always scrolls the page and only a horizontal drag moves the deck */
.fan-drag{position:absolute; inset:0; z-index:60; touch-action:pan-y; cursor:grab}
.fan-drag.dragging{cursor:grabbing}
.fan-drag:focus-visible{outline:2px solid var(--purple); outline-offset:-4px}
.fan-card{
  position:absolute; left:50%; top:50%; display:block; padding:0; border:0; background:none;
  width:clamp(186px,44vw,286px); aspect-ratio:460/628;
  border-radius:6px; overflow:hidden; pointer-events:none;
  transform-origin:50% 50%; will-change:transform;
}
.fan-card img{display:block; width:100%; height:100%; object-fit:cover}
.fan-hint{margin:22px 0 0; text-align:center}

/* ---------- answers ---------- */
.answer{padding:60px 0 0}
.answer .num{margin-bottom:12px}
.short{margin:8px 0 24px; max-width:46ch}
.ask{margin:30px 0 0; border-top:1px solid var(--border); padding-top:16px}
.ask p{margin:8px 0 0; max-width:56ch; color:var(--aubergine)}
.back{display:inline-block; text-decoration:none; padding:16px 0; min-height:44px}
.back .label{color:var(--mist)}
.back:hover .label{color:var(--purple)}

/* ---------- panels: a callout block, so an instrument never reads as prose ---------- */
.panel{
  background:var(--tint); padding:20px 20px 24px; margin:30px 0; position:relative;
}
@media (min-width:900px){
  .panel{margin-left:-28px; margin-right:-28px; padding-left:28px; padding-right:28px}
}
.panel-head{display:grid; grid-template-columns:10px auto; gap:12px; align-items:center; margin:0 0 14px}
.panel-head .seal{width:10px; height:10px; background:var(--champagne)}
.panel-head .label{color:var(--aubergine)}

.opts{display:flex; flex-wrap:wrap; gap:0 28px; margin:0 0 4px}
.opt{
  display:grid; grid-template-columns:8px auto; gap:10px; align-items:center;
  background:none; border:0; padding:13px 0; min-height:44px; cursor:pointer; text-align:left;
}
.opt .sq{width:8px; height:8px; background:transparent; box-shadow:inset 0 0 0 1px var(--mist)}
.opt[aria-pressed="true"] .label{color:var(--purple)}
.opt[aria-pressed="true"] .sq{background:var(--purple); box-shadow:inset 0 0 0 1px var(--purple)}

/* a metric row carries a NUMBER, on a 2px rule */
.metric{
  border-top:2px solid var(--aubergine); padding:10px 0 12px;
  display:flex; align-items:baseline; justify-content:space-between; gap:20px;
}
/* a state row carries a WORD, so its value is a mono label, never a figure */
.state{
  border-top:1px solid var(--border); padding:10px 0 12px;
  display:flex; align-items:baseline; justify-content:space-between; gap:20px;
}
.state .val{color:var(--aubergine)}
.note{margin:14px 0 0; max-width:56ch; color:var(--slate)}

.dia{display:block; width:100%; max-width:520px; height:auto; margin:2px auto 4px}
.dia-pair{display:grid; grid-template-columns:1fr; gap:26px; margin:6px auto 4px; max-width:620px}
@media (min-width:700px){ .dia-pair{grid-template-columns:1fr 1fr; gap:30px} }
.dia-pair figure{margin:0}
.dia-pair svg{display:block; width:100%; height:auto}
.dia-pair figcaption{margin-top:10px}
.dia-cap{margin-top:10px}
.dia text{font-family:var(--mono); font-weight:500; letter-spacing:.06em}
.dia .g{display:none}
.dia .g.on{display:block}

.cmp{margin:4px 0 0}
.cmp .row{margin:0 0 16px}
.cmp .row:last-child{margin-bottom:0}
.cmp .top{display:flex; justify-content:space-between; gap:16px; margin-bottom:6px}
.cmp .bar{height:6px; background:#E2DEE8}
.cmp .bar i{display:block; height:100%; background:var(--aubergine); transform:scaleX(0); transform-origin:0 50%}
.cmp .bar.years i{background:repeating-linear-gradient(90deg, var(--aubergine) 0 calc(10% - 3px), transparent calc(10% - 3px) 10%)}
.cmp.is-in .bar i{transform:scaleX(var(--w,1)); transition:transform 700ms cubic-bezier(.4,.14,.3,1) var(--d,0ms)}

/* the two sides of the privacy question, as one card split down the middle */
.panel.split{display:grid; grid-template-columns:1fr; gap:0; padding:0; overflow:hidden; background:none}
@media (min-width:700px){ .panel.split{grid-template-columns:1fr 1fr} }
.side{padding:22px 20px 24px}
@media (min-width:900px){ .side{padding:26px 28px 28px} }
.side--open{background:#E9E5F8}
.side--shut{background:var(--aubergine)}
.side-head{display:flex; align-items:center; gap:10px; margin:0 0 6px}
.dot{width:9px; height:9px; flex:none}
.dot--open{background:var(--purple)}
.dot--shut{background:var(--champagne)}
.side--open .label{color:var(--purple)}
.side--shut .label{color:var(--champagne)}
.side ul{list-style:none; margin:0; padding:0}
.side li{padding:11px 0; border-top:1px solid rgba(21,16,42,.12); font-size:15.5px; color:var(--ink); max-width:none}
.side--shut li{border-top-color:rgba(250,248,244,.16); color:rgba(250,248,244,.86)}

/* ---------- close and contact ---------- */
.close{padding:60px 0 0}
.cta-block{padding:44px 0 80px}
.btns{display:flex; flex-wrap:wrap; gap:12px; margin:24px 0 0}
.btn{
  display:inline-flex; align-items:center; justify-content:center;
  font-family:var(--ui); font-weight:500; font-size:16px; line-height:1;
  padding:15px 24px; min-height:48px; text-decoration:none; border:1px solid var(--aubergine);
  background:var(--aubergine); color:var(--bone); cursor:pointer;
}
.btn.ghost{background:transparent; color:var(--aubergine)}
.btn.ghost:hover{background:rgba(76,55,120,.028)}
.form{margin:36px 0 0; max-width:560px}
.field{margin:0 0 16px}
.field .label{margin-bottom:6px}
.field input, .field textarea{
  width:100%; font-family:var(--ui); font-size:16px; line-height:1.5; color:var(--aubergine);
  background:var(--bone); border:1px solid var(--border); padding:11px 12px; border-radius:0;
}
.field input:focus, .field textarea:focus{outline:2px solid var(--purple); outline-offset:1px; border-color:var(--purple)}
.field textarea{min-height:104px; resize:vertical}
.two{display:grid; grid-template-columns:1fr; gap:0 16px}
@media (min-width:640px){ .two{grid-template-columns:1fr 1fr} }
.colophon{margin:40px 0 0; border-top:1px solid var(--border); padding-top:16px}

@media (prefers-reduced-motion:reduce){
  html{scroll-behavior:auto}
  *{transition:none !important; animation:none !important}
  .up{opacity:1; transform:none}
  .line .rule{transform:scaleX(1)}
  .cmp .bar i{transform:scaleX(var(--w,1))}
}

/* ---------- site adjustments (requested after import) ---------- */
.short{border-left:2px solid var(--champagne); padding-left:18px}
@media (max-width:1239px){
  .rail{left:6px}
  .rail a{grid-template-columns:7px auto; gap:10px}
  .rail .seal{width:7px; height:7px}
  .rail .stem{left:2.5px; top:4px; bottom:4px}
  .rail li{margin-bottom:14px}
}
@media (max-width:899px){
  body{font-size:15.25px}
  .wrap{padding:0 22px 0 30px}
  .form .btns .btn{flex:1 1 auto; text-align:center}
}
`;
